import React from "react";
import { useEffect, useContext } from "react";
import "./homePage.css";
import TopBar from "../../../components/TopBarComponent/Topbar";
import CountBox from "../../../components/CountBoxComponent/CountBox";
import { Container } from "react-bootstrap";
import { HomePageContext } from "../HomeView";
import AlertBox from "../../../components/AlertComponent/AlertBox";
import { Spinner } from "react-bootstrap";
const HomePage = ({ textContents }) => {
  const {
    homeDataApi,
    homeData,
    profileDetail,
    profileData,
    showAlert,
    setShowAlert,
    statusCode,
    logout,
    alertMessage,
    setAlertMessage,
    showSpinner
  } = useContext(HomePageContext);

  useEffect(() => {
    homeDataApi();
    setInterval(() => homeDataApi(), 300000);
  }, []);

  const profileDataSharing = {
    name: profileData[0]?.name,
    Image: profileData[0]?.Image,
  };
  window.localStorage.setItem(
    "profileDataSharing",
    JSON.stringify(profileDataSharing)
  );
  useEffect(() => {
    profileDetail();
  }, []);
  return (
    <div>
      <TopBar />
      <Container className="homeContainer">
        <div className="totalCountContainerHome">
          <div className="totalCountInnerContainerHome">
            <span className="totalCountTextHome">{textContents.total}</span>
            <span className="totalCountTextHome">{textContents.count}</span>
          </div>
          <div className="dashedContainerHome"></div>
          <div className="totalCountBoxContainerHome">
          {showSpinner ? (
              <Spinner  size="xl" className="custom-spinner" />
            ) : (
              <span className="totalCountFontHome">{homeData?.total}</span>
            )}
           
          </div>
        </div>
        <div className="zoneOuterContainerHome">
          {homeData?.logs?.map((item, index) => {
            return (
              <CountBox
                key={index}
                employeeList={item?.category}
                zone={item?.name}
                count={item?.total}
              />
            );
          })}
        </div>
      </Container>
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        alertMessage={alertMessage}
        handleSubmit={
          statusCode == 401 ? () => logout() : () => setShowAlert(false)
        }
      />
    </div>
  );
};

export default HomePage;
